/* GLO "Haloven-style" PDP — shared interactions. Scoped to gh- classes only;
   does not touch the pp3v2 buy-box logic (that stays inline in gh-hero, unmodified). */
(function () {
  document.addEventListener("click", function (e) {
    var faqBtn = e.target.closest(".gh-faq-btn");
    if (faqBtn) {
      var item = faqBtn.closest(".gh-faq-item");
      var wasOpen = item.classList.contains("is-open");
      item.parentElement
        .querySelectorAll(".gh-faq-item.is-open")
        .forEach(function (o) {
          if (o !== item) o.classList.remove("is-open");
        });
      item.classList.toggle("is-open", !wasOpen);
      return;
    }

    var tab = e.target.closest(".gh-tab");
    if (tab) {
      var group = tab.closest(".gh-comparison");
      if (!group) return;
      var key = tab.getAttribute("data-tab");
      group.querySelectorAll(".gh-tab").forEach(function (t) {
        t.classList.toggle("is-on", t === tab);
      });
      group.querySelectorAll(".gh-cmp-alt-pane").forEach(function (p) {
        p.classList.toggle("is-on", p.getAttribute("data-tab") === key);
      });
      return;
    }
  });
})();
